import React from "react";
import { Link } from "react-router-dom"; 
export default function ServiceLayout({
  title,
  bannerImg,
  overviewImg,
  overviewHeading,
  overviewText,
  capabilities = [],
  buttonText = "Get a Custom Solution",
  buttonLink = "/contact",
  servicesHeading = "Our Services", 
  children,
}) {
  return (
    <>
      <section className="relative w-full">
        <img
          src={bannerImg}
          alt="Banner"
          className="w-full h-[220px] sm:h-[300px] md:h-[400px] lg:h-[500px] object-cover"
          loading="eager"
          fetchPriority="high"
          decoding="sync"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <h1
            className="text-white text-2xl sm:text-3xl md:text-5xl font-bold text-center px-4 drop-shadow-lg"
            data-aos="fade-down"
          >
            {title}
          </h1>
        </div>
      </section>
      
      <section className="py-12 sm:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-teal-500 uppercase tracking-wide font-medium mb-3">Overview</p>
            <h2 className="text-2xl md:text-3xl font-semibold mb-4">{overviewHeading}</h2>
            <p className="text-gray-700 mb-6">{overviewText}</p>

            {capabilities.length > 0 && (
              <>
                <h3 className="font-semibold text-lg mb-3">Key Capabilities:</h3>
                <ul className="list-disc list-inside space-y-2 text-gray-700 mb-8">
                  {capabilities.map((cap, index) => (
                    <li key={index}>
                      <strong>{cap.title}:</strong> {cap.description}
                    </li>
                  ))}
                </ul>
              </>
            )}

            <div className="text-center md:text-left">
              <Link
                to={buttonLink}
                className="inline-block bg-teal-600 text-white px-6 py-3 rounded-xl text-lg font-medium shadow-md hover:bg-teal-700 transition duration-300"
              >
                {buttonText}
              </Link>
            </div>
          </div>

          <div className="flex justify-center md:justify-end">
            <img
              src={overviewImg}
              alt="Overview"
              className="rounded-2xl shadow-xl w-full max-w-lg transform hover:scale-105 transition-transform duration-300"
              loading="eager"
              fetchPriority="high"
              decoding="sync"
            />
          </div>
        </div>
      </section>

      <section className="pt-4 px-4 sm:px-6 bg-white">
        <h2 className="text-3xl font-bold text-center mb-10">{servicesHeading}</h2>
        {children}
      </section>
    </>
  );
}
